import { Component, Input } from "@angular/core";
import { RestrictedNhsDataReason } from "./restricted-nhs-data-reason";
import { MiproSharedModule } from "@mipro/mipro-shared.module";
import { CommonModule } from "@angular/common";
import { NamingConventionService } from "@mipro/services/naming-convention.service";

@Component({
    selector: "medical-record-empty-list",
    standalone: true,
    imports: [CommonModule, MiproSharedModule],
    template: `
        <empty-list *ngIf="loading; else notLoading" [secondaryText]="loadingMessage"></empty-list>

        <ng-template #notLoading>
            <ng-container *ngIf="recordsCount <= 0">
                <ng-container [ngSwitch]="restrictedReason">
                    <empty-list
                        *ngSwitchCase="RestrictedReasons.None"
                        [primaryText]="primaryEmptyMessage"
                        [secondaryText]="secondaryEmptyMessage"></empty-list>

                    <empty-list
                        *ngSwitchCase="RestrictedReasons.PatientNotRegistered"
                        primaryText="Account Not Linked to NHS Records"
                        secondaryText="This account is currently not linked to an NHS account. To access NHS data, please ask the {{namingConvService.endUserSingular.toLowerCase()}} to link their NHS account and provide consent for data sharing"></empty-list>

                    <empty-list
                        *ngSwitchCase="RestrictedReasons.NoCqcOrganization"
                        secondaryText="This patient has no CQC-registered organisations"></empty-list>

                    <empty-list
                        *ngSwitchCase="RestrictedReasons.PatientPassport"
                        secondaryText="This patient has limited the display of this NHS data for this organisation"></empty-list>
                </ng-container>
            </ng-container>
        </ng-template>
    `
})
export class MedicalRecordEmptyListComponent {
    protected RestrictedReasons = RestrictedNhsDataReason;

    @Input() restrictedReason: RestrictedNhsDataReason;
    @Input() primaryEmptyMessage: string;
    @Input() secondaryEmptyMessage: string;
    @Input() recordsCount: number;
    @Input() loading: boolean;
    @Input() loadingMessage = "Bear with us whilst we update your NHS Data…";

    constructor(public namingConvService: NamingConventionService) {}
}
